import { FeatureFlags } from "@m7-health/shared-utils";
// eslint-disable-next-line deprecate/import
import { useFlags } from "launchdarkly-react-client-sdk";

import { useDeepMemo } from "./useDeepMemo";
import { useAppSelector } from "./useRedux";

export const useAppFlags = () => {
  const flags = useFlags<FeatureFlags.TReactFlags>();
  const featureFlagsOverrides = useAppSelector((state) => state.common.featureFlagsOverrides);

  return useDeepMemo(
    () => ({ ...flags, ...featureFlagsOverrides }),
    [flags, featureFlagsOverrides],
  );
};
